import object from '@mailobj-browser/front/js/utils/object.js'

export const block = 'ea_www'

export const elements = object(null, {
  container: `${block}__container`,
  title: `${block}__gallery_title`,
  list: `${block}__gallery_list`,
  item: `${block}__gallery_item`,
  image: `${block}__gallery_image`,
})

export const modifiers = object(null, {
  title: object(null, {
    focus: `${elements.title}-focus`,
  })
})
